import { captureTouch } from '../src/lib/attribution';
try { captureTouch(); } catch { /* Storage can be disabled. */ }
document.documentElement.classList.add('js');
const toggle = document.querySelector<HTMLButtonElement>('.menu-toggle');
const menu = document.getElementById('mobile-nav');
function closeMenu() { if (toggle && menu) { toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', 'Abrir menu'); menu.hidden = true; } }
closeMenu();
toggle?.addEventListener('click', () => {
 if (!menu) return;
 const expanded = toggle.getAttribute('aria-expanded') !== 'true';
 toggle.setAttribute('aria-expanded', String(expanded));
 toggle.setAttribute('aria-label', expanded ? 'Fechar menu' : 'Abrir menu');
 menu.hidden = !expanded;
});
document.addEventListener('keydown', event => { if (event.key === 'Escape' && toggle?.getAttribute('aria-expanded') === 'true') { closeMenu(); toggle.focus(); } });
matchMedia('(min-width: 761px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
function selectCase(id: string) {
 document.querySelectorAll<HTMLElement>('[data-case]').forEach(link => { const active = link.dataset.case === id; link.classList.toggle('active', active); link.setAttribute('aria-current', active ? 'true' : 'false'); });
 document.querySelectorAll<HTMLElement>('[data-case-panel]').forEach(panel => panel.classList.toggle('case-selected', panel.dataset.casePanel === id));
}
document.querySelectorAll<HTMLAnchorElement>('[data-case]').forEach(link => link.addEventListener('click', event => {
 if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
 event.preventDefault(); selectCase(link.dataset.case!);
 history.replaceState(null, '', `${location.pathname}${location.search}${link.hash}`);
}));
const initialCase = /^#caso-([0-2])$/.exec(location.hash);
if (initialCase) selectCase(initialCase[1]);
// Without JavaScript, all examples and the native FAQ accordions remain readable.
